module.exports = __webpack_public_path__ + "static/PT4-7941c52d9d790649d3c3fc76bf383d4e.jpg";